export const locale = {
  'INPROGRESS': {
    'TITLE': 'Orders in progress',
    'WITHOUT_APP': 'Without app',
  },
};
